<div class="modal-header">
    <h1>Request Support</h1>
</div>
<div class="modal-body" [ngStyle]="{'padding': requestSuccess == 'true' ? '20px 54px' :  '5px 15px'}">
    <!-- ---------------------request service content ------------------------------>
    <ng-container *ngIf="!requestSuccess">
        <h5>My personal ShoppeService &reg;</h5>
        <p class="bold-tag">Choose how you would like us to contact you:</p>
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li [ngbNavItem]="1">
                <a ngbNavLink>Phone</a>

                <ng-template ngbNavContent>
                    <ng-container
                        *ngIf="requestSupportData?.phoneServiceAvailable === 'true';then serviceAvailable else serviceNotAvailable ">
                    </ng-container>
                    <ng-template #serviceNotAvailable>
                        <div class="noPhoneService" [innerHTML]="requestSupportData?.noPhoneServiceMessage?.content">
                        </div>
                    </ng-template>
                    <ng-template #serviceAvailable>
                        <p>{{requestSupportData.phoneResponseTimeMessage}}</p>
                        <form [formGroup]="phoneForm">
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Phone (Area code and number)</label>
                                <input type="tel" [appMobMask]="'phone'" class="fieldInput" placeholder="123-456-7890"
                                    maxlength="12" formControlName="phone">
                                <span class="error" *ngIf="!PhoneControls.phone.valid && (PhoneControls.phone.dirty ||
                                PhoneControls.phone.touched) && PhoneControls.phone.errors?.required">This field is
                                    required</span>
                                <span class="error" *ngIf="!PhoneControls.phone.valid && (PhoneControls.phone.dirty ||
                                PhoneControls.phone.touched) && PhoneControls.phone.errors?.pattern">This field accepts
                                    numeric 10 digit phone number</span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Extension&nbsp;<span>(Optional)</span></label>
                                <input type="text" class="fieldInput" [ngStyle]="{'width': '25%'}"
                                    formControlName="extension" placeholder="123456" maxlength="6">
                                <span class="error" *ngIf="!PhoneControls.extension.valid && (PhoneControls.extension.dirty || PhoneControls.extension.touched) &&
                                PhoneControls.extension.errors?.pattern ">
                                    Please enter a valid extension </span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Confirm Phone</label>
                                <input type="tel" [appMobMask]="'phone'" class="fieldInput" maxlength="12"
                                    placeholder="123-456-7890" formControlName="cPhone"
                                    [ngClass]="{'red-border':PhoneControls.cPhone.valid && (PhoneControls.cPhone.dirty ||
                                PhoneControls.cPhone.touched) && PhoneControls.cPhone.value?.length > 0 && PhoneControls.cPhone.value != PhoneControls.phone.value }">
                                <span class="error" *ngIf="!PhoneControls.cPhone.valid && (PhoneControls.cPhone.dirty ||
                                PhoneControls.cPhone.touched) && PhoneControls.cPhone.errors?.required">This field is
                                    required</span>
                                <span class="error" *ngIf="!PhoneControls.cPhone.valid && (PhoneControls.cPhone.dirty ||
                                PhoneControls.cPhone.touched) && PhoneControls.cPhone.errors?.pattern">This field
                                    accepts numeric 10 digit phone number</span>
                                <span class="error"
                                    *ngIf="PhoneControls.cPhone.valid && (PhoneControls.cPhone.dirty ||
                                PhoneControls.cPhone.touched) && PhoneControls.cPhone.value?.length > 0 && PhoneControls.cPhone.value != PhoneControls.phone.value">Fields
                                    Do not match</span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Confirm Extension&nbsp;<span>(Optional)</span></label>
                                <input type="text" class="fieldInput" [ngStyle]="{'width': '25%'}" [ngClass]="{'red-border': PhoneControls.cExtension.valid && (PhoneControls.cExtension.touched && PhoneControls.cExtension.dirty) &&
                                    phoneForm.errors?.notMatch}" placeholder="123456" formControlName="cExtension"
                                    maxlength="6">
                                <span class="error" *ngIf="!PhoneControls.cExtension.valid && (PhoneControls.cExtension.dirty || PhoneControls.cExtension.touched) &&
                                PhoneControls.cExtension.errors?.pattern ">
                                    Please enter a valid extension </span>
                                <span class="error" *ngIf="PhoneControls.cExtension.valid && (PhoneControls.cExtension.touched && PhoneControls.cExtension.dirty) &&
                                phoneForm.errors?.notMatch">Fields do not match</span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">First Name</label>
                                <input type="text" class="fieldInput" formControlName="fName">
                                <span class="error" *ngIf="!PhoneControls.fName.valid && (PhoneControls.fName.dirty ||
                                PhoneControls.fName.touched) && PhoneControls.fName.errors?.required">This field is
                                    required</span>
                                <span class="error" *ngIf="!PhoneControls.fName.valid && (PhoneControls.fName.dirty || 
                                PhoneControls.fName.touched) && PhoneControls.fName.errors?.pattern">Please enter a
                                    valid name</span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Last Name</label>
                                <input type="text" class="fieldInput" formControlName="lName">
                                <span class="error" *ngIf="!PhoneControls.lName.valid && (PhoneControls.lName.dirty ||
                                PhoneControls.lName.touched) && PhoneControls.lName.errors?.required">This field is
                                    required</span>
                                <span class="error" *ngIf="!PhoneControls.lName.valid && (PhoneControls.lName.dirty || 
                                PhoneControls.lName.touched) && PhoneControls.lName.errors?.pattern">Please enter a
                                    valid name</span>
                            </div>
                            <div class="fieldsContainer d-flex flex-column">
                                <label class="fieldLabel">Please type your question or comment here</label>
                                <textarea class="fieldInput" formControlName="comments" cols="40" rows="4"></textarea>
                                <span class="error" *ngIf="!PhoneControls.comments.valid && (PhoneControls.comments.dirty ||
                                PhoneControls.comments.touched) && PhoneControls.comments.errors?.required">This field
                                    is required</span>
                            </div>
                        </form>
                    </ng-template>

                </ng-template>

            </li>
            <li [ngbNavItem]="2">
                <a ngbNavLink>Email</a>
                <ng-template ngbNavContent>
                    <p>{{requestSupportData?.emailResponseTimeMessage}}</p>
                    <form [formGroup]="emailForm" novalidate>
                        <div class="fieldsContainer d-flex flex-column">
                            <label class="fieldLabel">Subject</label>
                            <ng-select [items]="emailSubject" bindLabel="name" [clearable]="false"
                                formControlName="subject" placeholder="Please select">
                            </ng-select>
                            <span class="error" *ngIf="!EmailControls.subject.valid && (EmailControls.subject.dirty ||
                        EmailControls.subject.touched) && EmailControls.subject.errors?.required">This field is
                                required</span>
                        </div>
                        <div class="fieldsContainer dfd-flex flex-column"
                            *ngIf="EmailControls?.subject?.value?.code === 'OTHERS'">
                            <input type="text" class="fieldInput" formControlName="other">
                            <span class="error" *ngIf="!EmailControls.other.valid && (EmailControls.other.dirty ||
                        EmailControls.other.touched) && EmailControls.other.errors?.required">This field is
                                required</span>
                        </div>
                        <div class="fieldsContainer d-flex flex-column">
                            <label class="fieldLabel">First Name</label>
                            <input type="text" class="fieldInput" formControlName="fName">
                            <span class="error" *ngIf="!EmailControls.fName.valid && (EmailControls.fName.dirty ||
                        EmailControls.fName.touched) && EmailControls.fName.errors?.required">This field is
                                required</span>
                            <span class="error" *ngIf="!EmailControls.fName.valid && (EmailControls.fName.dirty ||
                        EmailControls.fName.touched) && EmailControls.fName.errors?.pattern">Please enter a valid
                                name</span>
                        </div>
                        <div class="fieldsContainer d-flex flex-column">
                            <label class="fieldLabel">Last Name</label>
                            <input type="text" class="fieldInput" formControlName="lName">
                            <span class="error" *ngIf="!EmailControls.lName.valid && (EmailControls.lName.dirty ||
                        EmailControls.lName.touched) && EmailControls.lName.errors?.required">This field is
                                required</span>
                            <span class="error" *ngIf="!EmailControls.lName.valid && (EmailControls.lName.dirty ||
                        EmailControls.lName.touched) && EmailControls.lName.errors?.pattern">Please enter a valid
                                name</span>
                        </div>
                        <div class="fieldsContainer d-flex flex-column">
                            <label class="fieldLabel">Please type your question or comment here</label>
                            <textarea class="fieldInput" formControlName="comments" cols="40" rows="4"></textarea>
                            <span class="error" *ngIf="!EmailControls.comments.valid && (EmailControls.comments.dirty ||
                        EmailControls.comments.touched) && EmailControls.comments.errors?.required">This field is
                                required</span>
                        </div>
                    </form>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="nav-outlet"></div>
        <p *ngIf="active == 2 || (active == 1 && requestSupportData?.phoneServiceAvailable === 'true') ">
            {{requestSupportData?.emailContactMessasge}}
        </p>
    </ng-container>

    <!-- ------------------------------------- -->

    <!-- ------------confirmation content-------------- -->
    <div class="d-flex flex-row" *ngIf="requestSuccess">
        <img src="{{getURL()}}" class="mr-2" alt="tickOrCross" [ngStyle]="{'height': '28px', 'width':'28px'}">
        <div [innerHTML]="requestSuccess == 'true' ? requestSupportData?.successPopupMessage.content : 
        requestSupportData?.errorPopupMessage.content"></div>
    </div>
    <!-- ----------------------------------------   -->
</div>
<div class="modal-footer" [ngStyle]="{'border-top': requestSuccess ? 0 : ''}">
    <div class="btns d-flex flex-column align-items-center">
        <button class="btn-primary mb-2 w-100" *ngIf="requestSuccess == undefined"
            [disabled]="active == 2 ? !emailForm.valid : !phoneForm.valid" (click)="requestService()">{{ active == 2 ?
            'Send Email' : 'Request Callback'}}</button>
        <button class="btn-secondary w-100" (click)="closeModal()">{{ requestSuccess ? 'Close': 'Cancel'}}</button>
    </div>
</div>